import { MenuIcon } from '@heroicons/react/solid';
import React, { useState } from 'react';
import RouteLink from 'view/common/elements/routeLink';
import Item from 'view/common/header/item';
import bulletLogo from '../../../img/uh_logo_bullet_white.png';
import fullLogo from '../../../img/uh_logo_white.png';
import {buttonCommon, outlineButton, blueButton} from "../../common/elements/classNames"
const Header = (props) => {
  const [menuClass, setMenuClass] = useState('hidden');
  const toggleMenu = () => {
    if(menuClass === 'hidden') {
      setMenuClass('visible');
    } else {
      setMenuClass('hidden');
    }
  }
  return ( 
    <div className='bg-uhnavy px-5 py-3'>
      <div className={`pr-6 pancakeHeader flex items-center justify-center lg:hidden relative`}>
          <div 
            className={`p-2 absolute hover:bg-uhblue hover:bg-opacity-40 rounded-full cursor-pointer`}  
            onClick={toggleMenu}
            style={{position:'absolute','left':'0'}}
          >
              <MenuIcon className='text-white h-7 w-7 block'/>
          </div>
          <div className={`w-1/2 md:w-1/3 lg:w-1/6 xl:w-1/6 block flex-grow  ${menuClass} absolute  \
            bg-white top-10 left-10 z-10 shadow-xl \
            border-uhblue-dark border rounded px-6 pb-4 pt-2 `}>
              <div className="text-sm">
                <Item
                    to="/"
                    label="Home"
                    onClick={toggleMenu}
                />
                <Item
                    to="/contactUs"
                    label="Contact Us"
                    onClick={toggleMenu}
                />
                <Item
                    to="/auth/login"
                    label="Login"
                    onClick={toggleMenu}
                />
                {/* <Item
                    to="/contactUs"
                    label="Sign Up"
                    onClick={toggleMenu}
                /> */}
                
                

                
              </div>
            </div>
          <div className='inline-block pl-10'>
            <a href="/">
              <img src={fullLogo} style={{maxWidth:'200px',margin:'auto'}} alt={"UH Logo"}/>
            </a>
            
          </div>
      </div>
      <div className='header text-white white hidden lg:flex'> 
        <div className='inline-block'>
          <a href="/">
            <img src={bulletLogo} style={{maxWidth:'60px'}}  alt={"UH Logo"}/>
          </a>
        </div>
        <div className='flex-1 inline-block flex items-center ml-10'>
          <RouteLink
            text="Home"
            href="/"
            className={`font-white font-bold`}
          />
          <RouteLink
            text="Contact Us"
            href="/contactUs"
            className={`font-white font-bold  ml-5`}
          />
          
        </div>
        <div className='inline-block'>
          <RouteLink
            text="Login"
            href="/auth/login"
            className={`font-white font-bold  ml-5`}
          />
          {/* <RouteLink
            text="Sign Up"
            href="/auth/register"
            className={`${blueButton} ${buttonCommon} ml-2`}
            style={{color:"#fff"}}
          /> */}
        </div>
      </div>
    </div>
  ) 
}

export default Header;